import {createMuiTheme} from '@material-ui/core/styles';

const responsiveFontSize = (px, theme) => {
  const minSize = 16;
  return {
    fontSize: `${(minSize + (px - minSize) * 0.2) / 16}em`,
    [theme.breakpoints.up(768)]: {
      fontSize: `${(minSize + (px - minSize) * 0.5) / 16}em`,
    },
    [theme.breakpoints.up(1024)]: {
      fontSize: `${(minSize + (px - minSize) * 0.6) / 16}em`,
    },
    [theme.breakpoints.up('lg')]: {
      fontSize: `${(minSize + (px - minSize) * 0.75) / 16}em`,
    },
    [theme.breakpoints.up(1440)]: {
      fontSize: `${(minSize + (px - minSize)) / 16}em`,
    },
  };
};

export default createMuiTheme({
  palette: {
    primary: {
      main: '#FFA000',
      light: '#FFECCC',
    },
    secondary: {
      main: '#ffffff',
      light: '#C0C0C0',
      dark: '#000000',
    },
    darkGrey: '#A0A0A0',
  },
  colors: {
    orange: '#FFA000',
    lightOrange: '#FFECCC',
    white: '#FFFFFF',
    lightGrey: '#C0C0C0',
    darkGrey: '#A0A0A0',
    black: '#000000',
  },
  typography: {
    hg80b: (theme) => ({
      ...responsiveFontSize(80, theme),
      fontFamily: ['HK Grotesk', 'sans-serif'],
      fontWeight: 'bold',
      lineHeight: '1.2em',
    }),
    hg80r: (theme) => ({
      ...responsiveFontSize(80, theme),
      fontFamily: ['HK Grotesk', 'sans-serif'],
      fontWeight: 'normal',
      lineHeight: '1.2em',
    }),
    hg54r: (theme) => ({
      // ...responsiveFontSize(54, theme),
      fontSize: 32,
      [theme.breakpoints.up(1024)]: {
        fontSize: 54,
      },
      fontFamily: ['HK Grotesk', 'sans-serif'],
      fontWeight: 'normal',
      lineHeight: '1.2em',
    }),
    hg54b: (theme) => ({
      // ...responsiveFontSize(54, theme),
      fontSize: 32,
      [theme.breakpoints.up(1024)]: {
        fontSize: 54,
      },
      fontFamily: ['HK Grotesk', 'sans-serif'],
      fontWeight: 'bold',
      lineHeight: '1.2em',
    }),
    hg36r: (theme) => ({
      // ...responsiveFontSize(36, theme),
      fontSize: 26,
      [theme.breakpoints.up(1024)]: {
        fontSize: 36,
      },
      fontFamily: ['HK Grotesk', 'sans-serif'],
      fontWeight: 'normal',
      lineHeight: '1.2em',
    }),
    hg36b: (theme) => ({
      // ...responsiveFontSize(36, theme),
      fontSize: 26,
      [theme.breakpoints.up(1024)]: {
        fontSize: 36,
      },
      fontFamily: ['HK Grotesk', 'sans-serif'],
      fontWeight: 'bold',
      lineHeight: '1.2em',
    }),
    hg36l: (theme) => ({
      // ...responsiveFontSize(36, theme),
      fontSize: 26,
      [theme.breakpoints.up(1024)]: {
        fontSize: 36,
      },
      fontFamily: ['HK Grotesk', 'sans-serif'],
      fontWeight: '300',
      lineHeight: '1.2em',
    }),
    hg24r: (theme) => ({
      ...responsiveFontSize(24, theme),
      fontFamily: ['HK Grotesk', 'sans-serif'],
      fontWeight: 'normal',
      lineHeight: '1.75em',
    }),
    hg24b: (theme) => ({
      ...responsiveFontSize(24, theme),
      fontFamily: ['HK Grotesk', 'sans-serif'],
      fontWeight: 'bold',
      lineHeight: '1.75em',
    }),
    hg24l: (theme) => ({
      ...responsiveFontSize(24, theme),
      fontFamily: ['HK Grotesk', 'sans-serif'],
      fontWeight: '300',
      lineHeight: '1.2em',
    }),
    hg20r: (theme) => ({
      ...responsiveFontSize(20, theme),
      fontFamily: ['HK Grotesk', 'sans-serif'],
      fontWeight: 'normal',
      lineHeight: '1.8em',
    }),
    hg18bu: (theme) => ({
      ...responsiveFontSize(18, theme),
      fontFamily: ['HK Grotesk', 'sans-serif'],
      fontWeight: 'bold',
      letterSpacing: '0.1em',
      lineHeight: '1.2em',
      textTransform: 'uppercase',
    }),
    hg18ru: (theme) => ({
      ...responsiveFontSize(18, theme),
      fontFamily: ['HK Grotesk', 'sans-serif'],
      fontWeight: 'normal',
      lineHeight: '1.33em',
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
    }),
    hg18r: (theme) => ({
      ...responsiveFontSize(18, theme),
      fontFamily: ['HK Grotesk', 'sans-serif'],
      fontWeight: 'normal',
      lineHeight: '1.67em',
    }),
    hg14r: (theme) => ({
      ...responsiveFontSize(14, theme),
      fontFamily: ['HK Grotesk', 'sans-serif'],
      fontWeight: 'normal',
      lineHeight: '1.2em',
    }),
    hg14bu: (theme) => ({
      ...responsiveFontSize(14, theme),
      fontFamily: ['HK Grotesk', 'sans-serif'],
      fontWeight: 'bold',
      letterSpacing: '0.1em',
      lineHeight: '1.2em',
      textTransform: 'uppercase',
    }),
    hg14i: (theme) => ({
      ...responsiveFontSize(14, theme),
      fontFamily: ['HK Grotesk', 'sans-serif'],
      fontStyle: 'italic',
      lineHeight: '1.2em',
    }),
    hg14b: (theme) => ({
      ...responsiveFontSize(14, theme),
      fontFamily: ['HK Grotesk', 'sans-serif'],
      fontWeight: 'bold',
      letterSpacing: '0.01em',
      lineHeight: '1.2em',
    }),
  },
  spacing: {
    unit: 15,
  },
  layout: {
    contentMaxWidth: 704,
    containerMaxWidth: '80em',
  }
});




// WEBPACK FOOTER //
// ./src/styles/theme.js